import * as yup from 'yup'

export const quotationAgreementsSchema = yup.lazy((obj) =>
  yup.object(
    Object.keys(obj || {}).reduce(
      (acc, key) => ({
        ...acc,
        [key]: yup.object({
          agreement: yup.string().required('Required'),
        }),
      }),
      {}
    )
  )
)
